<script setup lang="ts">
import { Component, inject } from 'vue'

withDefaults(
    defineProps<{
        sidebarBackgroundImage: string
        nextTab?: Component
        previousTab?: Component
    }>(),
    {
        sidebarBackgroundImage: null,
        nextTab: null,
        previousTab: null,
    }
)
const { navigateToNextTab } = inject('navigation')
</script>

<template>
    <div
        class="relative flex min-h-[500px] transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl">
        <div class="flex-column flex w-2/3 items-center justify-between">
            <div class="flex w-full flex-1 items-center">
                <div class="w-full">
                    <slot name="main"></slot>
                </div>
            </div>

            <div class="grid w-full grid-cols-2 border-t border-gray-200 px-6 py-5 sm:mt-6">
                <div class="justify-self-start">
                    <slot name="previousButton"></slot>
                </div>
                <div class="justify-self-end">
                    <slot name="nextButton"></slot>
                </div>
            </div>
        </div>

        <div class="relative h-auto w-1/3">
            <div
                class="absolute h-full w-full bg-cover opacity-10 backdrop-blur-2xl"
                :style="{ backgroundImage: 'url(' + sidebarBackgroundImage + ')' }"></div>
            <div class="relative flex h-full items-center px-4 pb-4 pt-5 sm:p-6">
                <div><slot name="sidebar"></slot></div>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
